import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown, Pause, Undo2 } from 'lucide-react';

function ThumbButtons({ onDecision, onUndo, canUndo = false }) {
  const handleDecision = (decision) => {
    onDecision(decision);
  };

  const handleUndo = () => {
    if (canUndo && onUndo) {
      onUndo();
    }
  };

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center">
      {/* Undo button positioned above the main buttons */}
      {canUndo && (
        <div className="mb-4">
          <button
            onClick={handleUndo}
            className="bg-muted-foreground text-white p-3 rounded-full shadow-lg hover:bg-foreground transition-colors hover:scale-110 transform duration-200 opacity-80 hover:opacity-100"
            title="Undo last decision (Ctrl+Z)"
          >
            <Undo2 className="w-6 h-6" />
          </button>
        </div>
      )}
      
      <div className="flex items-center gap-8 mb-4">
        <button
          onClick={() => handleDecision('rejected')}
          className="bg-red-500 text-white p-4 rounded-full shadow-lg hover:bg-red-600 transition-colors hover:scale-110 transform duration-200"
          title="Reject (Left Arrow)"
        >
          <ThumbsDown className="w-8 h-8" />
        </button>

        <button
          onClick={() => handleDecision('hold')}
          className="bg-yellow-500 text-white p-4 rounded-full shadow-lg hover:bg-yellow-600 transition-colors hover:scale-110 transform duration-200"
          title="Hold (Down Arrow)"
        >
          <Pause className="w-8 h-8" />
        </button>

        <button
          onClick={() => handleDecision('accepted')}
          className="bg-primary-dark text-white p-4 rounded-full shadow-lg hover:bg-primary-dark transition-colors hover:scale-110 transform duration-200"
          title="Accept (Right Arrow)"
        >
          <ThumbsUp className="w-8 h-8" />
        </button>
      </div>
    </div>
  );
}

export default ThumbButtons;